<template>
  <input-group title="権限がありません">
    <p>情報を参照する権限がありませんでした。</p>
    <p>申請番号が間違っていないかをご確認いただき、再度メールに添付のURLから申請番号確認を行ってください。</p>
  </input-group>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import InputGroup from '@/components/layout/InputGroup.vue'

/**
 * 申請基本 権限エラー画面
 */
export default defineComponent({
  name: 'ProximityAuthError',
  components: {
    InputGroup,
  },
})
</script>
